import {useTheme} from '@mui/styles';
import React, {useCallback} from 'react';
import {Bubbles} from '@management-ui/core';

const Materials = ({materials}) => {
  const theme = useTheme();

  const formatMaterial = useCallback(({id, name}) => (
    {id, label: name, colour: theme['palette'].secondary.main}
  ), [theme]);

  return materials?.length ? (
    <Bubbles bubbles={materials.map(m => formatMaterial(m))}/>
  ) : <i>None Associated</i>
};

export default Materials;
